import React, { FC } from 'react'
import { Slider } from '@components/Slider'
import { TestimonialType } from './types'
import { TestimonialCard } from './TestimonialCard'
import { TestimonialsSectionWrapper } from './TestimonialsSection.elements'

type Props = {
  testimonials: TestimonialType[]
}

export const TestimonialsSection: FC<Props> = ({ testimonials }) => {
  const slidesItems = testimonials.map((testimonial, index) => (
    <TestimonialCard key={index} {...testimonial} />
  ))

  return (
    <TestimonialsSectionWrapper>
      <Slider
        slides={slidesItems}
        autoTransition
      />
    </TestimonialsSectionWrapper>
  )
}
